import { useSearchParams } from "react-router-dom";

export default function useQueryParam(key) {
  const [searchParams] = useSearchParams();
  return searchParams.get(key);
}
